export const phone = '+66 94 9955 982';
export const email = 'bpsassetgroup@gmail.com';
export const line = 'https://line.me/ti/p/dpV806AM2w';
export const whatsapp = 'https://wa.me/+66949955982';
export const facebook =
  'https://www.facebook.com/profile.php?id=100095461785805';
